import { render, staticRenderFns } from "./heroSection.vue?vue&type=template&id=dbb75a52&scoped=true"
import script from "./heroSection.vue?vue&type=script&lang=ts"
export * from "./heroSection.vue?vue&type=script&lang=ts"
import style0 from "./heroSection.vue?vue&type=style&index=0&id=dbb75a52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb75a52",
  null
  
)

export default component.exports